"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prettyPrintBaseTheme = function (_breakpoints) { return ({
    "@global": {
        ".prettyprint .pln": { color: "#000" },
        "@media screen": {
            ".prettyprint .str": { color: "#080" },
            ".prettyprint .kwd": { color: "#008" },
            ".prettyprint .com": { color: "#800" },
            ".prettyprint .typ": { color: "#606" },
            ".prettyprint .lit": { color: "#066" },
            ".prettyprint .pun, .prettyprint .opn, .prettyprint .clo": {
                color: "#660"
            },
            ".prettyprint .tag": { color: "#008" },
            ".prettyprint .atn": { color: "#606" },
            ".prettyprint .atv": { color: "#080" },
            ".prettyprint .dec, .prettyprint .var": { color: "#606" },
            ".prettyprint .fun": { color: "red" }
        },
        "@media print, projection": {
            ".prettyprint .str": { color: "#060" },
            ".prettyprint .kwd": { color: "#006", fontWeight: "bold" },
            ".prettyprint .com": { color: "#600", fontStyle: "italic" },
            ".prettyprint .typ": { color: "#404", fontWeight: "bold" },
            ".prettyprint .lit": { color: "#044" },
            ".prettyprint .pun, .prettyprint .opn, .prettyprint .clo": {
                color: "#440"
            },
            ".prettyprint .tag": { color: "#006", fontWeight: "bold" },
            ".prettyprint .atn": { color: "#404" },
            ".prettyprint .atv": { color: "#060" }
        },
        "pre.prettyprint": { padding: "2px", border: "1px solid #888" },
        ".prettyprint  .prettyprint ol.linenums": {
            marginTop: "0",
            marginBottom: "0"
        },
        ".prettyprint li.L0, .prettyprint li.L1, .prettyprint li.L2, .prettyprint li.L3, .prettyprint li.L5, .prettyprint li.L6, .prettyprint li.L7, .prettyprint li.L8": {
            listStyleType: "none"
        },
        ".prettyprint  .prettyprint li.L1, .prettyprint li.L3, .prettyprint li.L5, .prettyprint li.L7, .prettyprint li.L9": {
            background: "#eee"
        }
    },
}); };
exports.default = prettyPrintBaseTheme;
//# sourceMappingURL=prettyprint.js.map